import React from "react";
import { Icon } from "../core/Icon.jsx";

// Der Auslöser hebt sich nicht hervor — er zeigt am Rahmen, dass die Liste offen ist.
// Hervorgehoben wird die Option unter dem Zeiger, und zwar über .erp-select in
// tokens/base.css. Vorher schrieb das Ereignis am DOM-Knoten herum; blieb ein
// mouseleave aus, standen zwei Optionen gleichzeitig hell.
export function Select({ options = [], value, placeholder, onSelect, height, disabled = false, style = {} }) {
  const [open, setOpen] = React.useState(false);
  const wrap = React.useRef(null);
  React.useEffect(() => {
    if (!open) return;
    const down = (e) => { if (wrap.current && !wrap.current.contains(e.target)) setOpen(false); };
    const key = (e) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", down, true);
    document.addEventListener("keydown", key, true);
    return () => { document.removeEventListener("mousedown", down, true); document.removeEventListener("keydown", key, true); };
  }, [open]);
  const h = height || 26;
  return (
    <div ref={wrap} style={{ position: "relative", width: "100%", ...style }}>
      <button title={value || ""} disabled={disabled} onClick={() => setOpen(!open)} style={{
        display: "flex", alignItems: "center", gap: 6, width: "100%", height: h, padding: "0 8px",
        background: disabled ? "var(--bg-field-off)" : "var(--bg-field)",
        border: "1px solid " + (open ? "var(--line-l)" : "var(--line-d)"), borderRadius: "var(--r-field)",
        color: value ? "var(--fg-1)" : "var(--fg-9)", fontFamily: "inherit", fontSize: "var(--type-value-size)",
        cursor: disabled ? "default" : "pointer", textAlign: "left", outline: "none",
      }}>
        <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{value || placeholder || "\u00a0"}</span>
        <span style={{ display: "flex", flex: "none", color: "var(--ico-d)", transition: "transform var(--dur-normal) ease", transform: "rotate(" + (open ? 180 : 0) + "deg)" }}><Icon name="chevron-down" size={12} /></span>
      </button>
      {open ? (
        <div style={{
          position: "absolute", left: 0, right: 0, top: h + 4, zIndex: 61, minWidth: "100%", maxHeight: 240, overflowY: "auto",
          background: "var(--bg-pop)", border: "1px solid var(--line-b)", borderRadius: "var(--r-tile)",
          boxShadow: "var(--shadow-popover)", padding: 4,
        }}>
          {options.map((o) => (
            <div key={o} onClick={() => { setOpen(false); if (onSelect) onSelect(o); }} className="erp-select"
              style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 8px", borderRadius: 5, cursor: "pointer", fontSize: "var(--fs-12)", color: o === value ? "var(--fg-active)" : "var(--fg-3)", background: "var(--select-hot-bg, transparent)", whiteSpace: "nowrap" }}>
              <span style={{ width: 13, flex: "none", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--ac-blue)", opacity: o === value ? 1 : 0 }}><Icon name="check" size={12} strokeWidth={3} /></span>
              <span style={{ flex: 1 }}>{o}</span>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
